import {store, getContext, getElement} from '@wordpress/interactivity';

const universalLock =
    'I acknowledge that using a private store means my plugin will inevitably break on the next store release.';

// Access the shared WooCommerce products store to read variation data.
const {state: wooProductsState} = store('woocommerce/products', {}, {lock: universalLock});

store('wc-stripe/single-product-express', {
    state: {
        isHydrated: false,
    },
    callbacks: {
        onInit() {
            // Intentionally empty — isHydrated is unused; instanceCache handles first-run detection.
            // Kept to match the onInit/onWatch pattern used in the mini-cart integration.
        },
        onVariationChanged() {
            const {ref} = getElement();
            const productsContext = getContext('woocommerce/products');
            const attributeContext = getContext('woocommerce/add-to-cart-with-options');
            const variationId = productsContext?.variationId ?? null;

            const attributes = getAttributeValues(attributeContext?.selectedAttributes || []);

            if (variationId) {
                const variation = wooProductsState.productVariations?.[variationId]
                    ? {...wooProductsState.productVariations[variationId], attributes}
                    : null;
                document.dispatchEvent(new CustomEvent('wc-stripe:single-product-variation-changed', {
                    detail: {variationId, variation, container: ref}
                }));
            } else {
                document.dispatchEvent(new CustomEvent('wc-stripe:single-product-variation-reset', {
                    detail: {container: ref}
                }));
            }
        },
    },
});

const getAttributeValues = (values) => {
    return values.reduce((acc, curr) => {
        return {
            ...acc,
            [`attribute_${curr.attribute.toLowerCase()}`]: curr.value
        }
    }, {});
}
